import React, { useState, useEffect } from "react";
import {
  Box,
  VStack,
  Flex,
  Text,
  Td,
  Select,
  useDisclosure,
  Button,
  Stack,
  Input,
  FormLabel,
  IconButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  Image,
  TabPanel,
} from "@chakra-ui/react";
import Table from "../../components/common/Table";
import axios from "axios";
import { FaPrint, FaSync, FaEdit, FaTrashAlt } from "react-icons/fa";
import Modali from "./Modal";
import { BASE_URL } from "../../Globalapi/Globalapi";

const Sub_Result = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [examResults, setExamResults] = useState([]);
  const [categories, setCategories] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [userId, setUserId] = useState(null);
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [editExam, setEditExam] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [divisions, setDivisions] = useState([]);
  const [selectedDivision, setSelectedDivision] = useState("");
  const [grades, setGrades] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const headers = [
    "Student Name",
    "Written Marks",
    "Internal Marks",
    "Total Marks",
    "Grade",
    "Compliment",
    // "Exam Date",
    "Actions",
  ];
  const [academicId, setAcademicId] = useState(
    sessionStorage.getItem("Academic")
  );

  useEffect(() => {
    const handleStorageChange = () => {
      setAcademicId(sessionStorage.getItem("Academic"));
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  useEffect(() => {
    const storedUserId = sessionStorage.getItem("user_id");
    if (storedUserId) {
      setUserId(storedUserId);
    } else {
      console.error("User ID not found in session storage.");
    }

    const fetchFilters = async () => {
      try {
        const [
          classResponse,
          divisionResponse,
          subjectResponse,
          gradeResponse,
        ] = await Promise.all([
          axios.get(`${BASE_URL}/admin/class/class_master.php`),
          axios.get(`${BASE_URL}/admin/class/division.php`),
          axios.post(
            `${BASE_URL}/admin/subject/list_all_subject_to_teacher.php`,
            {
              pass: storedUserId,
            }
          ),
          axios.get(`${BASE_URL}/admin/exam/list_all_grade_master.php`),
        ]);

        setClasses(classResponse.data.data || []);
        setDivisions(divisionResponse.data.data || []);
        setSubjects(subjectResponse.data.data || []);
        setGrades(gradeResponse.data.data || []);
      } catch (error) {
        setErrorMessage("Error fetching filter options: " + error.message);
      }
    };

    fetchFilters();
  }, []);

  const fetchExamResults = async () => {
    const token = sessionStorage.getItem("jwt");
    if (!selectedClass || !selectedSubject) {
      setErrorMessage("Please select both class and subject.");
      return;
    }

    setLoading(true);
    setErrorMessage(null);
    try {
      const response = await axios.post(
        `${BASE_URL}/admin/exam/list_result_to_subteacher.php`,
        // JSON.stringify({
        //   pass: userId,
        //   class_id: selectedClass,
        //   division_id: selectedDivision,
        //   subject_id: selectedSubject,
        //   school_id: sessionStorage.getItem("school_id"),
        // }),
        JSON.stringify({
          pass: userId,
          class_id: Number(selectedClass),
          division_id: Number(selectedDivision),
          subject_id: Number(selectedSubject),
          school_id: sessionStorage.getItem("school_id"),
        }),

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: ` Bearer ${token}`,
          },
        }
      );

      // console.log("U", userId);
      // console.log("C", selectedClass);
      // console.log("D", selectedDivision);
      // console.log("S", selectedSubject);
      // console.log("SChool id", sessionStorage.getItem("school_id"));
      console.log("APImm Response:", response.data); // Log the full response

      if (response.data.success) {
        setExamResults(response.data.exam_results || []);
        console.log("Response:", response.data.exam_results);

        // Extract unique categories from the exam results
        const uniqueCategories = [
          ...new Set(
            response.data.exam_results.flatMap((result) =>
              result.exam_data.map((exam) => exam.category)
            )
          ),
        ];

        console.log("====================================");
        console.log("cat", uniqueCategories);
        console.log("====================================");
        setCategories(uniqueCategories);
        // console.log("@@cat@@", categories);
      } else {
        setErrorMessage("No results found");
        setExamResults([]);
      }
    } catch (error) {
      setErrorMessage("Error fetching exam results: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   const interval = setInterval(fetchExamResults, 1000);

  //   // Cleanup on component unmount
  //   return () => clearInterval(interval);
  // }, [selectedClass, selectedSubject, selectedDivision]);

  useEffect(() => {
    if (selectedClass && selectedSubject) {
      fetchExamResults();
    }
  }, [selectedClass, selectedSubject, selectedDivision, userId]);

  // const filteredResults = (category) =>
  //   examResults
  //     .map((result) => {
  //       // Filter exam_data based on category and academicId
  //       const filteredExamData = result.exam_data.filter(
  //         (exam) =>
  //           exam.category === category && exam.academic_year_id === academicId
  //       );

  //       // If no matching exam_data, remove this result
  //       if (filteredExamData.length === 0) return null;

  //       return {
  //         ...result,
  //         exam_data: filteredExamData,
  //       };
  //     })
  //     .filter(Boolean) // Remove null values
  //     .filter((result) =>
  //       result.student_name?.toLowerCase().startsWith(searchTerm.toLowerCase())
  //     );

  const filteredResults = (category) => {
    // academicId-യെ സംഖ്യയായി പരിവർത്തനം ചെയ്യുക (string-ൽ നിന്ന് number-ലേക്ക്)
    const academicIdNum = Number(academicId);

    return examResults
      .map((result) => {
        // Filter exam_data based on category and academicId
        const filteredExamData = result.exam_data.filter(
          (exam) =>
            exam.category === category &&
            Number(exam.academic_year_id) === academicIdNum
        );

        // ... ബാക്കി കോഡ്
        if (filteredExamData.length === 0) return null;
        return {
          ...result,
          exam_data: filteredExamData,
        };
      })
      .filter(Boolean) // ... ബാക്കി കോഡ്
      .filter((result) =>
        result.student_name?.toLowerCase().startsWith(searchTerm.toLowerCase())
      );
  };

  // console.log("====================================");
  // console.log("result", filteredResults);
  // console.log("====================================");

  const handleDelete = async (examId) => {
    try {
      const token = sessionStorage.getItem("jwt");
      console.log("Deleting result with exam_id:", examId);

      // Send the exam_id in the request body as JSON
      const response = await axios.delete(
        `${BASE_URL}/staff/exam/delete_exam_result.php`,
        {
          data: { id: examId }, // Send the data as JSON
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        // Filter out the deleted result from state
        setExamResults((prevResults) =>
          prevResults.filter((result) => result.exam_id !== examId)
        );
      } else {
        setErrorMessage("Failed to delete exam result");
      }
    } catch (error) {
      setErrorMessage("Error deleting exam result: " + error.message);
    }
  };

  // const handleEdit = (resultId) => {
  //   const examToEdit = examResults.find((exam) => exam.id === resultId); // Find by id, not exam_id
  //   if (examToEdit) {
  //     setEditExam({ ...examToEdit });
  //     setIsModalOpen(true);
  //   }
  // };

  const handleEdit = (examId) => {
    // Loop through each student's result
    for (const result of examResults) {
      // Loop through each exam entry for that student
      const examToEdit = result.exam_data.find((exam) => exam.id === examId);

      // If a match is found, set the state and open the modal
      if (examToEdit) {
        setEditExam(examToEdit);
        setIsModalOpen(true);
        return; // Exit the loop once the item is found
      }
    }
    console.error("Exam with ID", examId, "not found.");
  };

  const handleSaveEdit = async () => {
    const token = sessionStorage.getItem("jwt"); // Ensure token is defined
    if (!editExam) return;

    try {
      const response = await axios.put(
        `${BASE_URL}/staff/exam/edit_exam_result.php`,
        JSON.stringify(editExam),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: ` Bearer ${token}`, // Use backticks for template literal
          },
        }
      );

      if (response.data.success) {
        setIsModalOpen(false); // Close the modal after saving
        setEditExam(null); // Reset after saving
        fetchExamResults(); // Fetch updated data from the server
      } else {
        setErrorMessage("Failed to update exam result");
      }
    } catch (error) {
      setErrorMessage("Error updating exam result: " + error.message);
    }
  };

  const handleChangeEdit = (e) => {
    const { name, value } = e.target;
    setEditExam((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Pagination logic
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = examResults.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(examResults.length / rowsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const renderRow = (result) =>
    result.exam_data.map((exam, index) => (
      <>
        <Td p={2} fontSize="sm">
          {result.student_name || "N/A"}
        </Td>
        <Td p={2} fontSize="sm">
          {exam.written_mark || "N/A"}
        </Td>
        <Td p={2} fontSize="sm">
          {exam.internal_mark || "N/A"}
        </Td>
        <Td p={2} fontSize="sm">
          {exam.marks || "N/A"}
        </Td>
        <Td p={2} fontSize="sm">
          {exam.grade || "N/A"}
        </Td>
        <Td p={2} fontSize="sm">
          {exam.compliment || "N/A"}
        </Td>
        <Td p={2} fontSize="sm">
          <IconButton
            icon={<FaEdit />}
            aria-label="Edit"
            size="sm"
            mr={2}
            onClick={() => handleEdit(exam.id)}
          />
          <IconButton
            icon={<FaTrashAlt />}
            aria-label="Delete"
            size="sm"
            onClick={() => handleDelete(exam.id)}
          />
        </Td>
      </>
    ));

  return (
    <Box borderRadius="md" mx="auto">
      <div style={{ backgroundColor: "#FBFBFD" }}>
        <div className="teacher-list-container">
          <div className="header">
            <h1 style={{ fontSize: "20px", margin: 0 }}>Exam Result</h1>
            <div className="action-buttons">
              <Button
                className="refresh-button"
                boxShadow="md"
                backgroundColor="white"
                fontSize="11px"
                onClick={() => fetchExamResults()}
                display={{ base: "none", md: "flex" }}
              >
                <FaSync color="#515B73" />
              </Button>
              <div className="export-dropdown">
                <Button
                  className="export-button"
                  backgroundColor="white"
                  fontSize="11px"
                  boxShadow="md"
                  display={{ base: "none", md: "flex" }}
                >
                  <FaPrint color="#515B73" />
                  Print PDF
                </Button>
              </div>
              <Button onClick={onOpen} colorScheme="teal">
                Add Marks
              </Button>
            </div>
          </div>
          <div className="breadcrumb">
            <span>Staff</span> / <span>Exam</span> / <span>Exam Result </span>
          </div>
        </div>
        <Modali isOpen={isOpen} onClose={onClose} />

        <VStack spacing={4} align="stretch" p={6}>
          <Box width="100%" borderRadius="md">
            <Flex
              align="center"
              justify="center" // Center align all elements horizontally
              direction={{ base: "column", md: "row" }} // Stack vertically on mobile and horizontally on larger screens
              gap={4} // Add spacing between items
              width="100%" // Ensure Flex container takes full width
            >
              <Flex
                gap={4}
                direction={{ base: "column", md: "row" }} // Stack vertically on mobile, horizontally on larger screens
                align="center"
                justify="center" // Center align items horizontally
                wrap="wrap" // Allow wrapping if needed on smaller screens
                width="100%" // Ensure Flex container takes full width
              >
                {/* Filters */}
                <Select
                  placeholder="Select Class"
                  onChange={(e) => setSelectedClass(e.target.value)}
                  width={{ base: "100%", md: "auto" }} // Full width on mobile, auto width on desktop
                >
                  {classes.map((cls) => (
                    <option key={cls.id} value={cls.id}>
                      {cls.class}
                    </option>
                  ))}
                </Select>
                <Select
                  placeholder="Select Division"
                  onChange={(e) => setSelectedDivision(e.target.value)}
                  width={{ base: "100%", md: "auto" }} // Full width on mobile, auto width on desktop
                >
                  {divisions.map((division) => (
                    <option key={division.id} value={division.id}>
                      {division.division}
                    </option>
                  ))}
                </Select>
                <Select
                  placeholder="Select Subject"
                  onChange={(e) => setSelectedSubject(e.target.value)}
                  width={{ base: "100%", md: "auto" }} // Full width on mobile, auto width on desktop
                >
                  {subjects.map((sub) => (
                    <option key={sub.subject_id} value={sub.subject_id}>
                      {sub.subject}
                    </option>
                  ))}
                </Select>
                <Input
                  placeholder="Search by Student Name"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  width={{ base: "100%", md: "300px" }} // Full width on mobile, fixed width on desktop
                />
              </Flex>

              {/* Search Bar wrapped with Flex on larger devices */}
              {/* <Flex
                direction={{ base: "column", md: "row" }} // Stack vertically on mobile, horizontally on larger screens
                width={{ base: "100%", md: "auto" }} // Full width on mobile, auto width on larger screens
              >
           
              </Flex> */}
            </Flex>
          </Box>

          {categories.length > 0 ? (
            <Tabs isLazy>
              <TabList
                // mb={4}
                border="none"
                display="flex"
                justifyContent="center"
                flexWrap="wrap"
              >
                {categories.map((category) => (
                  <Tab
                    key={category}
                    _selected={{
                      color: "white",
                      bg: "teal.500",
                      fontWeight: "bold",
                      borderRadius: "lg",
                    }}
                    _hover={{
                      bg: "teal.100",
                    }}
                    fontSize="md"
                    fontWeight="semibold"
                    // px={6}
                    // py={3}
                    mx={2}
                  >
                    {category}
                  </Tab>
                ))}
              </TabList>

              <TabPanels>
                {categories.map((category) => (
                  <TabPanel key={category} p={4}>
                    <Table
                      headers={headers}
                      data={filteredResults(category)}
                      renderRow={renderRow}
                    />
                  </TabPanel>
                ))}
              </TabPanels>
            </Tabs>
          ) : (
            <Text
              marginTop="50px"
              as="h2"
              textAlign="center"
              fontSize="lg"
              fontWeight="semibold" // Corrected from "semi-bold" to "semibold"
              color="teal.600" // Elegant teal shade from Chakra UI's color palette
            >
              Please select class, division, and subject for result.
            </Text>
          )}

          {/* <Flex justify="end" borderTopWidth="1px" className="sb2" mt={1} p={3}>
            <Button
              onClick={() => handlePageChange(currentPage - 1)}
              isDisabled={currentPage === 1}
            >
              Prev
            </Button>
            <Stack direction="row" mx={2}>
              {currentPage > 1 && (
                <>
                  <Button onClick={() => handlePageChange(1)}>1</Button>
                  {currentPage > 2 && <Text>...</Text>}
                </>
              )}
              <Button backgroundColor="teal" color="white">
                {currentPage}
              </Button>
              {currentPage < totalPages - 1 && (
                <>
                  <Text>...</Text>
                  <Button onClick={() => handlePageChange(totalPages)}>
                    {totalPages}
                  </Button>
                </>
              )}
            </Stack>
            <Button
              onClick={() => handlePageChange(currentPage + 1)}
              isDisabled={currentPage === totalPages}
            >
              Next
            </Button>
          </Flex> */}
        </VStack>
      </div>
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Edit Exam Result</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Stack spacing={4}>
              <FormLabel htmlFor="written_marks">Written Marks</FormLabel>
              <Input
                id="written_marks"
                name="written_mark"
                value={editExam?.written_mark || ""}
                onChange={handleChangeEdit}
                size="sm"
              />
              <FormLabel htmlFor="internal_marks">Internal Marks</FormLabel>
              <Input
                id="internal_marks"
                name="internal_mark"
                value={editExam?.internal_mark || ""}
                onChange={handleChangeEdit}
                size="sm"
              />
              <FormLabel htmlFor="marks">Total Marks</FormLabel>
              <Input
                id="marks"
                name="marks"
                value={editExam?.marks || ""}
                onChange={handleChangeEdit}
                size="sm"
              />
              <FormLabel htmlFor="grade">Grade</FormLabel>
              <Select
                id="grade"
                name="grade"
                value={editExam?.grade || ""}
                onChange={handleChangeEdit}
                size="sm"
              >
                <option value="">Select Grade</option>
                {grades.map((grade) => (
                  <option key={grade.grade_id} value={grade.grade_id}>
                    {grade.grade}
                  </option>
                ))}
              </Select>
            </Stack>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="teal" onClick={handleSaveEdit}>
              Save
            </Button>
            <Button variant="ghost" onClick={() => setIsModalOpen(false)}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default Sub_Result;
